const moment = require('moment')

// 每几位中间加个字符
export const returnStrByInfo = function (currentStr, lengths = 4, addStr = ' ') {
  if (currentStr && typeof currentStr === 'number') { currentStr = String(currentStr) }
  if (!currentStr || typeof currentStr !== 'string') return
  const array = currentStr.split('')
  let _str = ''
  array.forEach((v, i) => {
    if ((i + 1) % lengths === 0 && i != 0) {
      _str += v + addStr
    } else {
      _str += v
    }
  })
  return _str
}

export const FormatTime = (_date, _pattern, text) => {
  if (!_date) return text || ''
  _pattern = _pattern || 'YYYY-MM-DD HH:mm:ss'
  return moment(_date * 1).format(_pattern)
}

export const OutputTitle = title => {
  const Obj = {
    PGM: 'PGM',
    VFB: 'Video Return',
    Share: 'Share',
    Broadcaster: 'Broadcaster'
  }
  return Obj[title] || ''
}

export default {
  returnStrByInfo,
  FormatTime,
  OutputTitle
}
